import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIndicator)?_c('div',{staticClass:"cursor-help"},[_c(VTooltip,{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VIcon,_vm._g(_vm._b({staticClass:"data-table-icon-cell-offset"},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.compIcon))])]}}],null,false,3292712650)},[_c('span',{staticClass:"ws-pre-wrap"},[_vm._v(_vm._s(_vm.compTooltipText))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }